(() => {
  'use strict';

  if (window.__drevosMobileModelRail) return;
  window.__drevosMobileModelRail = true;

  const locale = (document.documentElement.lang || 'pl').toLowerCase();
  const mobileCatalogMedia = window.matchMedia('(max-width: 749px)');
  const destinationPath = (href) => {
    try {
      const url = new URL(href || '', window.location.origin);
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (error) {
      return href || '';
    }
  };

  const pushEvent = (eventName, parameters = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({
      event: eventName,
      experiment_id: 'home_mobile_models',
      experiment_variant: 'D',
      component: 'home_model_selector',
      locale
    }, parameters));
  };

  const cardParameters = (card) => ({
    section_id: card.closest('[data-dmmr-root]')?.dataset.sectionId || '',
    model_handle: card.dataset.modelHandle || card.dataset.model || '',
    model_name: card.dataset.modelName || '',
    model_group: card.dataset.modelGroup || 'home',
    model_position: Number(card.dataset.position || 0),
    destination_path: destinationPath(card.getAttribute('href')),
    price: Number(card.dataset.priceCents || 0) / 100,
    currency: card.dataset.currency || 'PLN'
  });

  const syncCatalogAnchor = (root) => {
    if (!root) return;
    root.dataset.dmmrOriginalId = root.dataset.dmmrOriginalId || root.id;
    const legacyCatalog = document.querySelector('[data-dmmr-legacy-catalog]') || document.querySelector('#katalog');

    if (mobileCatalogMedia.matches) {
      if (legacyCatalog && legacyCatalog !== root) {
        legacyCatalog.dataset.dmmrLegacyCatalog = 'true';
        legacyCatalog.id = 'katalog-legacy';
      }
      root.id = 'katalog';
      return;
    }

    if (legacyCatalog && legacyCatalog !== root && legacyCatalog.dataset.dmmrLegacyCatalog === 'true') {
      legacyCatalog.id = 'katalog';
      delete legacyCatalog.dataset.dmmrLegacyCatalog;
    }
    root.id = root.dataset.dmmrOriginalId;
  };

  const initRoot = (root) => {
    if (!root || root.dataset.dmmrReady === 'true') return;
    root.dataset.dmmrReady = 'true';
    syncCatalogAnchor(root);
    mobileCatalogMedia.addEventListener('change', () => syncCatalogAnchor(root));

    const cards = Array.from(root.querySelectorAll('[data-home-model-card]'));
    const impressionTimers = new WeakMap();
    const impressedCards = new WeakSet();

    const sectionObserver = new IntersectionObserver((entries) => {
      const visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > .02);
      document.documentElement.classList.toggle('drevos-mobile-model-rail-visible', visible);
    }, { threshold: [0, .02, .1] });
    sectionObserver.observe(root);

    const cardObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const card = entry.target;
        const existingTimer = impressionTimers.get(card);

        if (entry.isIntersecting && entry.intersectionRatio >= .5 && !impressedCards.has(card)) {
          if (existingTimer) return;
          const timer = window.setTimeout(() => {
            if (impressedCards.has(card)) return;
            impressedCards.add(card);
            impressionTimers.delete(card);
            cardObserver.unobserve(card);
            pushEvent('home_model_impression', cardParameters(card));
          }, 1000);
          impressionTimers.set(card, timer);
        } else if (existingTimer) {
          window.clearTimeout(existingTimer);
          impressionTimers.delete(card);
        }
      });
    }, { threshold: [.5] });

    cards.forEach((card) => {
      cardObserver.observe(card);
      card.addEventListener('click', (event) => {
        const part = event.target.closest('[data-home-model-target]');
        pushEvent('home_model_click', Object.assign(cardParameters(card), {
          target: part ? part.dataset.homeModelTarget : 'card'
        }));
      });
    });

    const catalogLink = root.querySelector('[data-home-catalog-link]');
    if (catalogLink) {
      catalogLink.addEventListener('click', () => {
        pushEvent('home_catalog_click', {
          section_id: root.dataset.sectionId || '',
          placement: 'after_models',
          destination_path: destinationPath(catalogLink.getAttribute('href'))
        });
      });
    }

    const moreModels = root.querySelector('[data-home-more-models]');
    if (moreModels) {
      moreModels.addEventListener('toggle', () => {
        if (!moreModels.open) return;
        pushEvent('home_more_models_open', {
          section_id: root.dataset.sectionId || '',
          placement: 'after_home_models',
          model_group: 'smoke_chamber_and_pro'
        });
      });
    }
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-dmmr-root]').forEach(initRoot);
  };

  const consentState = (event) => {
    const detail = event?.detail || {};
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    const fromDetail = (key) => typeof detail[key] === 'boolean' ? detail[key] : null;
    const fromApi = (method) => {
      try {
        return privacy && typeof privacy[method] === 'function' ? Boolean(privacy[method]()) : false;
      } catch (error) {
        return false;
      }
    };

    return {
      analytics: fromDetail('analyticsAllowed') ?? fromApi('analyticsProcessingAllowed'),
      marketing: fromDetail('marketingAllowed') ?? fromApi('marketingAllowed'),
      preferences: fromDetail('preferencesAllowed') ?? fromApi('preferencesProcessingAllowed'),
      saleOfData: fromDetail('saleOfDataAllowed') ?? fromApi('saleOfDataAllowed')
    };
  };

  const trackConsentChoice = (event) => {
    const state = consentState(event);
    const granted = state.analytics && state.marketing && state.preferences;
    const denied = !state.analytics && !state.marketing && !state.preferences;

    pushEvent('cookie_action', {
      component: 'shopify_customer_privacy',
      action: granted ? 'all_granted' : (denied ? 'all_denied' : 'custom'),
      analytics_allowed: Number(state.analytics),
      marketing_allowed: Number(state.marketing),
      preferences_allowed: Number(state.preferences),
      sale_of_data_allowed: Number(state.saleOfData)
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('visitorConsentCollected', trackConsentChoice);
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-cc-reopen], #shopify-pc__banner__btn-manage-prefs')) return;
    pushEvent('cookie_action', {
      component: 'shopify_customer_privacy',
      action: 'preferences_open'
    });
  }, true);
})();
